import React from "react";

//components
import ViewHeader from "../components/Template/ViewHeader";

import {
  //Table
  CTable,
  CTableRow,
  CTableHead,
  CTableBody,
  CTableDataCell,
  CTableHeaderCell,
} from "@coreui/react";

import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";
import { ChevronDown, ChevronUp } from "react-feather";
import useLocalStorage from "use-local-storage";
import LoadingCenter from "../components/LoadingCenter";

const Ranking = (props) => {
  const [order, setOrder] = React.useState("");
  const [ranking, setRanking, loading, error, request] = useAxiosFunction();

  React.useEffect(() => {
    request({
      axiosInstance,
      method: "GET",
      url: "/users/ranking?order=" + order,
      redirect_to: "",
      data: {}
    });
  }, [order]);

  const currency = function (number) {
    return new Intl.NumberFormat(
      "pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2
    }).format(number);
  };

  const [theme] = useLocalStorage("theme");

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Ranking de clientes</span>
      </div>

      <div className="dashboard__container">
        {loading && <LoadingCenter />}
        {!loading &&
          <CTable color={theme} borderless hover>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell scope="col"></CTableHeaderCell>
                <CTableHeaderCell scope="col">Nome</CTableHeaderCell>
                <CTableHeaderCell scope="col" className="u-text-center">
                  <span className="mr-20">Valor Total Vendido</span>
                  <span className="btn-table-cell" onClick={() => setOrder("TotalReais")}>
                    {order === "TotalReais"
                      ? <ChevronUp size={24} />
                      : <ChevronDown size={24} />}
                  </span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col" className="u-text-center">
                  <span className="mr-20">Arremates</span>
                  <span className="btn-table-cell" onClick={() => setOrder("QtdArremates")}>
                  {order === "QtdArremates"
                    ? <ChevronUp size={24} />
                    : <ChevronDown size={24} />}
                  </span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col" className="u-text-center">Participações</CTableHeaderCell>
                <CTableHeaderCell scope="col" className="u-text-center">Conversão</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
            {ranking && ranking.map((purchaser, i) => {
              return (
                <CTableRow key={i}>
                  {i + 1 === 1 && (
                    <CTableDataCell className="u-text-center">
                      <img src={require("../imgs/medalha-de-ouro.png")} />
                    </CTableDataCell>
                  )}
                  {i + 1 === 2 && (
                    <CTableDataCell className="u-text-center">
                      <img src={require("../imgs/medalha-de-prata.png")} />
                    </CTableDataCell>
                  )}
                  {i + 1 === 3 && (
                    <CTableDataCell className="u-text-center">
                      <img src={require("../imgs/medalha-de-bronze.png")} />
                    </CTableDataCell>
                  )}
                  {i + 1 > 3 && (
                    <CTableDataCell className="u-text-center">
                      {i + 1}
                    </CTableDataCell>
                  )}
                  <CTableDataCell>{purchaser.name}</CTableDataCell>
                  <CTableHeaderCell className="u-text-center">{currency(purchaser.totalValor)}</CTableHeaderCell>
                  <CTableDataCell className="u-text-center">{purchaser.qtdArremates}</CTableDataCell>
                  <CTableDataCell className="u-text-center">{purchaser.qtdParticipacao}</CTableDataCell>
                  <CTableDataCell className="u-text-center">{((purchaser.qtdArremates * 100) / purchaser.qtdParticipacao).toFixed(0)}%</CTableDataCell>
                </CTableRow>
              )
            })}
            </CTableBody>
          </CTable>}
      </div>
    </div>
  );
}

export default Ranking;